import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieForm } from '@/features/series-management';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/series/create/')({
  component: SerieCreatePage,
});

/** Página de criação de Série. */
export function SerieCreatePage() {
  const { t } = useTranslation('series');
  const navigate = useNavigate();

  const goBack = () => void navigate({ to: '/series' });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('series.form.createTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('series.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('series.form.createTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      <SerieForm serie={null} onSaved={goBack} onCancel={goBack} />
    </div>
  );
}
